<div class="mob-abrir-conta mob-box-container container">
  <div class="row">
    <div class="col-12">
      <div class="mob-image d-none-sm">
        <img
          [attr.src]="VO?.step_by_step_image?.MediaImagemProposta_bloblink_ | normalizeImage:isMock:'step-by-step-image'"
          alt="mobile"
        />
      </div>
      <div>
        <div class="mob-title-3 mb-40">{{ VO?.step_by_step?.title }}</div>
        <div
          class="mob-infos mb-40"
          [innerHTML]="VO?.step_by_step?.description"
        ></div>
        <div class="mob-title-2 mb-16">
          <strong>{{ VO?.step_by_step_footer?.title }}</strong>
        </div>
        <div
          class="mob-text-8"
          [innerHtml]="VO?.step_by_step_footer?.description"
        ></div>
      </div>
    </div>
  </div>
</div>
